export enum GeofenceAlarmTrigger {
  ENTERING = 'ENTERING',
  LEAVING = 'LEAVING',
}
